import Joi from 'joi';
import type { ExtractValues, SchemaOf } from '../helpers';
import { objectSchemaOf } from '../helpers';

export const snapshotType = [
  'face',
  'far',
  'forward',
  'person',
  'periodical',
  'start',
] as const;

export type SnapshotType = ExtractValues<typeof snapshotType>;

export const snapshotMetaSchemaMap: SchemaOf<ISnapshotMeta> = {
  snapshotId: Joi.string().required(),
  consoleId: Joi.string().required(),
  conversationId: Joi.string().required(),
  timestamp: Joi.number().required(),
  device: Joi.string().required(),
  version: Joi.string().required(),
  type: Joi.string()
    .valid(...snapshotType)
    .required(),
};

export const snapshotMetaSchema = objectSchemaOf<ISnapshotMeta>(
  snapshotMetaSchemaMap
);

export interface ISnapshotMeta {
  snapshotId: string;
  consoleId: string;
  conversationId: string;
  timestamp: number;
  device: string;
  version: string;
  type: SnapshotType;
}
